const blue = {
  10: "#e9f9ff",
  20: "#bceaf8",
  30: "#85d8ee",
  40: "#60bdd6",
  50: "#309ab5",
  60: "#007b94",
  70: "#006074",
  80: "#00495a",
  90: "#003543",
  100: "#002530",
} as const;

const green = {
  10: "#dcffe6",
  20: "#92f7b6",
  30: "#68e398",
  40: "#50c680",
  50: "#2ba160",
  60: "#008247",
  70: "#006539",
  80: "#004d2b",
  90: "#003920",
  100: "#002815",
} as const;

const yellow = {
  10: "#fff7d4",
  20: "#f9e466",
  30: "#e7cc00",
  40: "#d1ad00",
  50: "#b98500",
  60: "#a75f00",
  70: "#943c00",
  80: "#7c2200",
  90: "#611200",
  100: "#470a00",
} as const;

const red = {
  10: "#fff4f1",
  20: "#ffdad3",
  30: "#ffbcb0",
  40: "#fd9484",
  50: "#f35a4b",
  60: "#d13630",
  70: "#ad1717",
  80: "#8b0000",
  90: "#690000",
  100: "#4d0000",
} as const;

const gray = {
  10: "#f6f6f7",
  20: "#e1e2e5",
  30: "#caccd1",
  40: "#adb1b8",
  50: "#898e97",
  60: "#6d7178",
  70: "#54575d",
  80: "#404247",
  90: "#2e3034",
  100: "#202224",
} as const;

const sabreRed = "#e50000" as const;
const katanaBlack = "#121315" as const;

export const theme = {
  palette: {
    "sabre-red": sabreRed,
    "katana-black": katanaBlack,
    "select-blue": blue[60],
    white: "#ffffff",
    blue,
    green,
    yellow,
    red,
    gray,
    text: {
      primary: gray[80],
      dark: katanaBlack,
    },
  },
};
